/** @format */

import styled from 'styled-components';

const StyledOpenSpan = styled.span`
  width: fit-content;
  display: flex;
  user-select: none;
`;

export default StyledOpenSpan;
